import { VRButton } from "three/examples/jsm/webxr/VRButton";
import { LoadScene } from '../apis/loadScene';
import { GetUserModel } from '../apis/getUserModel';
import { defaultModelData } from './defaltModelData';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';
import { XRControllerModelFactory } from 'three/examples/jsm/webxr/XRControllerModelFactory.js';
import { Player } from "./Player";
import '../style.css';

import * as THREE from 'three';

let camera, scene, renderer;
let group, group1; 
let raycaster;
let player;
let dolly, dummyCam;
let controller1, controller2;
let mouseHelper;
let controllerGrip1, controllerGrip2;
const tempMatrix = new THREE.Matrix4( );    
const debugObject = {};
const playerPosition = new THREE.Vector3(0,1,0);
const cameraVector = new THREE.Vector3()
const prevGamePads = new Map();
var speedFactor = [0.1, 0.1, 0.1, 0.1];



/**
 * Loaders
 */
 const gltfLoader = new GLTFLoader();
 const cubeTextureLoader = new THREE.CubeTextureLoader();

 const per_loader = document.querySelector(".loader-percentage")
 
var VRRoom = function () {

    scene = new THREE.Scene();
    group = new THREE.Group();
    group1 = new THREE.Group();
    scene.add(group);
    scene.add(group1);

    renderer = new THREE.WebGLRenderer({
        antialias: true 
    });
    renderer.xr.enabled = true;
    renderer.physicallyCorrectLights = true
    renderer.toneMapping = THREE.ReinhardToneMapping;
    renderer.toneMappingExposure = 2;
    renderer.setSize(window.innerWidth, window.innerHeight);
    renderer.setPixelRatio(Math.min(window.devicePixelRatio, 2));
    document.body.appendChild(renderer.domElement);

    document.body.appendChild( VRButton.createButton( renderer ) );

    // camera
    camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 0.1, 1000);
    camera.position.set(0, 3.6, 0);

    //ambient light
    const alight = new THREE.AmbientLight( 0x404040, 20 ); // soft white light
    scene.add( alight );

    setEnvironment();

    //setDirectionLight();

    loadRoomEnvironment();

    player = newPlayer();

    addMouseHelper();

    //controllers

    const geometry = new THREE.BufferGeometry();
    geometry.setFromPoints([new THREE.Vector3(0, 0, 0), new THREE.Vector3(0, 0, - 20)]);

    controller1 = renderer.xr.getController(0);
    controller1.addEventListener('selectstart', onSelectStart);
    
    controller1.add(new THREE.Line(geometry));
    scene.add(controller1);
    dolly.add(controller1);

    controller2 = renderer.xr.getController(1);
    controller2.addEventListener('selectstart', onPositionSelectStart);
    controller2.add(new THREE.Line(geometry));
    scene.add(controller2);
    dolly.add(controller2);

    const controllerModelFactory = new XRControllerModelFactory();

    controllerGrip1 = renderer.xr.getControllerGrip(0);
    controllerGrip1.add(controllerModelFactory.createControllerModel(controllerGrip1));
    scene.add(controllerGrip1);
    dolly.add(controllerGrip1)

    controllerGrip2 = renderer.xr.getControllerGrip(1);
    controllerGrip2.add(controllerModelFactory.createControllerModel(controllerGrip2));
    scene.add(controllerGrip2);
    dolly.add(controllerGrip2)

    raycaster = new THREE.Raycaster();

    window.addEventListener( 'resize', onWindowResize );

    function onWindowResize() {

        camera.aspect = window.innerWidth / window.innerHeight;
        camera.updateProjectionMatrix();
        renderer.setSize( window.innerWidth, window.innerHeight );

    }

}

function setEnvironment() {
    // const loader = new RGBELoader().setDataType( THREE.UnsignedByteType );
    // const pmremGenerator = new THREE.PMREMGenerator( renderer );
    // pmremGenerator.compileEquirectangularShader();
    
    // //loader.load( '/textures/venice_sunset_1k.hdr', ( texture ) => {
    // loader.load( '/textures/Scifi_env_v3.hdr', ( texture ) => {
      
    //   const envMap = pmremGenerator.fromEquirectangular( texture ).texture;
    //   pmremGenerator.dispose();

    //   //scene.environment = envMap;
    //   scene.background = envMap
    //   debugObject.envMapIntensity = 2.7
    //   //gui.add(debugObject, 'envMapIntensity').min(0).max(10).step(0.1).onChange(updateAllMaterials)

    // }, undefined, (err)=>{
    //     console.error( 'An error occurred setting the environment');
    // } );

    const environmentMap = cubeTextureLoader.load([
        '/textures/environmentMaps/0/pz.png', //nani diwal px ->  pz
        '/textures/environmentMaps/0/nz.png', // nano glass nx -> nz
        '/textures/environmentMaps/0/py1.png',
        '/textures/environmentMaps/0/ny.png',
        '/textures/environmentMaps/0/nx.png',  // moti diwal pz -> nx
        '/textures/environmentMaps/0/px.png'   // moto glass nz -> px
    ])

    environmentMap.encoding = THREE.sRGBEncoding

    scene.background = environmentMap
    //scene.environment = environmentMap

    debugObject.envMapIntensity = 2.7
}

function loadRoomEnvironment(){
    gltfLoader.setPath('/models/');
    gltfLoader.load('Main_Hall_v13.glb', function (gltf) {
        gltf.scene.traverse(function (child) {
            if(child instanceof THREE.Mesh){
                child.geometry.computeVertexNormals();
                if(child.name == 'mesh_10'){
                    child.material.opacity = 0;
                    child.material.needsUpdate = true;
                }
            }
        })
        group.add(gltf.scene);
        console.log(scene);
        updateAllMaterials();
        animate();
        // console.log(renderer.info.render)
    },
    function ( xhr ) {
        per_loader.innerHTML = '' ;
        let percentage = ( xhr.loaded / xhr.total * 100 )
        if(percentage < 100){
            per_loader.innerHTML = 'Scene Loading....' ;
        }    
    });
}

const updateAllMaterials = () => {
    scene.traverse((child) => {
        if (child instanceof THREE.Mesh && child.material instanceof THREE.MeshStandardMaterial) {
            if(child.name == 'Glass'){
                child.material.transparent = true;
                child.material.needsUpdate = true;
            }
            // child.material.envMap = environmentMap
            child.material.envMapIntensity = debugObject.envMapIntensity
            child.material.needsUpdate = true
            child.castShadow = true
            child.receiveShadow = true
        }
    })
}

function onSelectStart(event) {

    const controller = event.target;

    const intersections = getIntersections(controller);
    console.log(intersections)

    if (intersections.length > 0) {

        const intersection = intersections[0];
        // const object = intersection.object;
        console.log(intersection);
        playerPosition.copy(intersection.point);
        //player.object.position.copy(intersection.point)
        
        //controller.userData.selected = object;
    }

}

function getIntersections( controller ) {


	tempMatrix.identity( ).extractRotation( controller.matrixWorld );

	raycaster.ray.origin.setFromMatrixPosition( controller.matrixWorld );
	raycaster.ray.direction.set( 0, 0, - 1 ).applyMatrix4( tempMatrix );

	return raycaster.intersectObjects( scene.children[0].children[0].children[0].children[0].children[10].children[0].children, false );

}

function onPositionSelectStart(){

    console.log('Select button 2 pressed')

}

function newPlayer(){
    const target = new THREE.Object3D();
    target.position.set(0, 0.25, 0); 
    
    const options = {
                object: target,
                speed: 5,
                app: scene,
                name: 'player',
                npc: false
            };
            
    const player = new Player(options);
       
    dolly = new THREE.Object3D();
    dolly.position.set(0, 0.25, 0);
    dolly.add(camera);
    
    dummyCam = new THREE.Object3D();
    camera.add( dummyCam );
    
    target.add(dolly);
    
    dolly.rotation.y = 0;
    
    return player;
}

function addMouseHelper(){
    var helperMaterial = new THREE.MeshBasicMaterial();
    helperMaterial.transparent = true;
    helperMaterial.opacity = 0.2;
    var helperGeometry = new THREE.CircleBufferGeometry(0.2, 64);
    mouseHelper = new THREE.Mesh(helperGeometry, helperMaterial);

    var ringMaterial = new THREE.MeshBasicMaterial();
    ringMaterial.transparent = true;
    ringMaterial.opacity = 0.8;
    var ringGeometry = new THREE.RingBufferGeometry(0.2, 0.22, 64);
    var ring = new THREE.Mesh(ringGeometry, ringMaterial);
    mouseHelper.add(ring);

    mouseHelper.visible = false;

    ring.renderOrder = 2;
    mouseHelper.renderOrder = 2;

    scene.add(mouseHelper);
}

function animate( ) {

	renderer.setAnimationLoop( render );

}

function render( ) {

    const intersects = getIntersections(controller1);

    if ( intersects.length > 0 ) {
        mouseHelper.position.set(intersects[0].point.x, intersects[0].point.y, intersects[0].point.z);
        //mouseHelper.rotation.x = Math.PI/2;
        mouseHelper.visible = true;
    }
    //dollyMove();

	//intersectObjects( controller1 );
	//intersectObjects( controller2 );
    player.object.position.lerp(playerPosition, 0.05)

	renderer.render( scene, camera );

}

function dollyMove() {
	var handedness = "unknown";

	//determine if we are in an xr session
	const session = renderer.xr.getSession();
	let i = 0;

	if (session) {
		let xrCamera = renderer.xr.getCamera(camera);
		xrCamera.getWorldDirection(cameraVector);

		//a check to prevent console errors if only one input source
		if (isIterable(session.inputSources)) {
			for (const source of session.inputSources) {
				if (source && source.handedness) {
					handedness = source.handedness; //left or right controllers
				}
				if (!source.gamepad) continue;
				const controller = renderer.xr.getController(i++);
				const old = prevGamePads.get(source);
				const data = {
					handedness: handedness,
					buttons: source.gamepad.buttons.map((b) => b.value),
					axes: source.gamepad.axes.slice(0)
				};
				if (old) {
					data.axes.forEach((value, i) => {
						//handlers for thumbsticks
						//if thumbstick axis has moved beyond the minimum threshold from center, windows mixed reality seems to wander up to about .17 with no input
						if (Math.abs(value) > 0.2) {
							//set the speedFactor per axis, with acceleration when holding above threshold, up to a max speed
							speedFactor[i] > 1 ? (speedFactor[i] = 1) : (speedFactor[i] *= 1.001);
							console.log(value, speedFactor[i], i);
							if (i == 2) {
								//left and right axis on thumbsticks
								if (data.handedness == "left") {
									// (data.axes[2] > 0) ? console.log('left on left thumbstick') : console.log('right on left thumbstick')

									//move our dolly
									//we reverse the vectors 90degrees so we can do straffing side to side movement
									player.object.rotation.y -= speedFactor[i] * data.axes[2];
								} 
							}

							if (i == 3) {
								//up and down axis on thumbsticks
								if (data.handedness == "left") {
									// (data.axes[3] > 0) ? console.log('up on left thumbstick') : console.log('down on left thumbstick')
									
								} else {
									// (data.axes[3] > 0) ? console.log('up on right thumbstick') : console.log('down on right thumbstick')
									//player.object.position.x -= cameraVector.x * speedFactor[i] * data.axes[3];
									//player.object.position.z -= cameraVector.z * speedFactor[i] * data.axes[3];
								}
							}
						} else {
							//axis below threshold - reset the speedFactor if it is greater than zero  or 0.025 but below our threshold
							if (Math.abs(value) > 0.025) {
								speedFactor[i] = 0.025;
							}
						}
					});
				}
				prevGamePads.set(source, data);
			}
		}
	}
}

function isIterable(obj) {
	// checks for null and undefined
	if (obj == null) {
		return false;
	}
	return typeof obj[Symbol.iterator] === "function";
}

export async function loadModelafterLoginVR() {
    const sceneData = await LoadScene();
    console.log(sceneData)
    if (sceneData)
        loadSceneData(sceneData.result.models);
}

async function loadSceneData(sceneData) {
    console.log(sceneData)
    var data = await GetUserModel()
    let userModels
    if (data) {
        userModels = data.result
    }

    sceneData.map(model => {
        console.log(model)
        defaultModelData.map(item => {
            if (model.modelId == item.modelId) {
                console.log(item.modelUrl)
                new GLTFLoader().load(item.modelUrl, function (gltf) {
                    gltf.scene.traverse((child) => {
                        if (child instanceof THREE.Mesh) {
                            child.userData.position = { "x": model.modelPosition.x, "y": model.modelPosition.y, "z": model.modelPosition.z };
                            if (model.modelRotation)
                                child.userData.rotation = { "x": model.modelRotation.x, "y": model.modelRotation.y, "z": model.modelRotation.z };
                            child.userData.id = item.modelId;
                            child.userData.userModel = false;
                        }
                    })
                    gltf.scene.position.set(model.modelPosition.x, model.modelPosition.y, model.modelPosition.z);
                    if (model.modelRotation)
                        gltf.scene.rotation.set(model.modelRotation.x, model.modelRotation.y, model.modelRotation.z);
                    group1.add(gltf.scene);
                    console.log(gltf.scene)
                    animate();
                });
            }
            // let modelName = item.modelUrl.split("/")[item.modelUrl.split("/").length - 1];
            // let loader = new GLTFLoader().setPath('https://aurainteract.com/library/agwxr/3d/');
            // let loader = new GLTFLoader().setPath('https://aurainteract.com/library/agwxr/3d/');
        })
        userModels.map(item => {
            if (model.modelId == item.modelId) {
                console.log(item.modelUrl)
                new GLTFLoader().load(item.modelUrl, function (gltf) {
                    gltf.scene.traverse((child) => {
                        if (child instanceof THREE.Mesh) {
                            child.userData.position = { "x": model.modelPosition.x, "y": model.modelPosition.y, "z": model.modelPosition.z };
                            if (model.modelRotation)
                                child.userData.rotation = { "x": model.modelRotation.x, "y": model.modelRotation.y, "z": model.modelRotation.z };
                            child.userData.id = item.modelId;
                            child.userData.userModel = false;
                        }
                    })
                    gltf.scene.position.set(model.modelPosition.x, model.modelPosition.y, model.modelPosition.z);
                    if (model.modelRotation)
                        gltf.scene.rotation.set(model.modelRotation.x, model.modelRotation.y, model.modelRotation.z);
                    group1.add(gltf.scene);
                    console.log(gltf.scene)
                    animate();
                });
            }
            // let modelName = item.modelUrl.split("/")[item.modelUrl.split("/").length - 1];
            // let loader = new GLTFLoader().setPath('https://aurainteract.com/library/agwxr/3d/');
            // let loader = new GLTFLoader().setPath('https://aurainteract.com/library/agwxr/3d/');
        })
    })
}

export { VRRoom };